/*=========================================================================================
  File Name: module-agreement-getters.js
  Description: LicenseAgreement Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	getAuditingLogs(state) {
		return state.AuditingLogs;
	},
	getAuditingLogTotal(state) {
		return state.AuditingLogTotal;
	},
	TermOfUseResult(state) {
		return state.TermOfUseResult.Data;
	}
};